module.exports = __webpack_public_path__ + "img/spine3.426b1c09.jpg";